export enum ProviderClientSource {
    MALOU = 'malou',
    ZENCHEF = 'zenchef',
    ZELTY = 'zelty',
    LAFOURCHETTE = 'lafourchette',
    COMO = 'como',
}

export enum ProviderClientCivility {
    MALE = 'male',
    FEMALE = 'female',
    OTHER = 'other',
}

export interface ProviderClientPhone {
    prefix: string;
    digits: string;
}

export enum OrderChannel {
    WEB = 'web',
    MOBILE = 'mobile',
    KIOSK = 'kiosk',
    POS = 'pos',
    UBEREATS = 'ubereats',
    DELIVEROO = 'deliveroo',
    OTHER = 'other',
}

export enum ReservationChannel {
    WEB = 'web',
    MOBILE = 'mobile',
    WALK_IN = 'walk_in',
    TRIPADVISOR = 'tripadvisor',
    MICHELIN = 'michelin',
    THE_FORK = 'the_fork',
    GOOGLE = 'google',
    BACK_OFFICE = 'back_office',
    PARTNER = 'partner',
    OTHER = 'other',
}

export enum VisitMode {
    EAT_IN = 'eat_in',
    TAKEAWAY = 'takeaway',
    DELIVERY = 'delivery',
}

export enum ProviderVisitStatus {
    RECORDED = 'recorded',
    CANCELLED = 'cancelled',
    NO_SHOW = 'no_show',
    PENDING = 'pending',
}

export enum ProviderActionType {
    PLAY_WHEEL_OF_FORTUNE = 'play_wheel_of_fortune',
    PRIVATE_REVIEW_FROM_WHEEL_OF_FORTUNE = 'private_review_from_wheel_of_fortune',
    PRIVATE_REVIEW_FROM_NFC = 'private_review_from_nfc',
    PRIVATE_REVIEW_FROM_CAMPAIGN = 'private_review_from_campaign',
    RETRIEVE_WHEEL_OF_FORTUNE_GIFT = 'retrieve_wheel_of_fortune_gift',
    CAMPAIGN_EMAIL_SENT = 'campaign_email_sent',
}

export enum ProviderActionRelatedEntityType {
    GIFT_DRAW = 'GiftDraw',
    CAMPAIGN = 'Campaign',
    PRIVATE_REVIEW = 'PrivateReview',
}

export enum Civility {
    MALE = 'male',
    FEMALE = 'female',
    OTHER = 'other',
}

export enum ContactMode {
    EMAIL = 'email',
    SMS = 'sms',
}

export enum ClientSource {
    MANUAL = 'manual',
    MALOU = 'malou',
    ZENCHEF = 'zenchef',
    ZELTY = 'zelty',
    LAFOURCHETTE = 'lafourchette',
    PULP = 'pulp',
    WHEEL_OF_FORTUNE = 'wheel_of_fortune',
    TOTEMS = 'totems',
}

export enum ClientVariable {
    FIRSTNAME = '#CLIENT_FIRSTNAME#',
    LASTNAME = '#CLIENT_LASTNAME#',
}

export const clientsFilesFormat = Object.freeze([
    {
        key: 'zenchef',
        headers: [
            'Prenom',
            'Nom',
            'Email',
            'Telephone',
            'Pays',
            'Statut destinataire',
            'Email optin market',
            'Date inscription mail',
            'SMS optin market',
            'Date inscription SMS',
            'Email optin review',
            'Date inscription avis par mail',
            'SMS review market',
            'Date inscription avis par SMS',
            'lang',
            'vip',
            'has_no_show',
            'is_new',
            'is_blacklisted',
            'retention_rate_label',
            'retention_rate',
            'has_opt_in_market_mail',
            'has_opt_in_review_mail',
            'created_at',
            'updated_at',
        ],
        required: ['Prenom', 'Nom', 'Telephone', 'Email'],
    },
    {
        key: 'pulp',
        headers: [''],
        required: [''],
    },
    {
        key: 'lafourchette',
        headers: [
            'Civilité',
            'Prénom',
            'Nom',
            'Pays',
            'Ville',
            'Code Postal',
            'Adresse',
            'Mobile Personnel',
            'Email personnel',
            'Langue',
            "Date d'inscription",
            'Newsletter',
            'Date de naissance',
            'Statut',
            'VIP',
            'Fax Personnel',
            "Complément d'adresse",
            'Prescripteur',
            'Commission négociée',
            "Nombre d'apport d'affaire total",
            "Chiffre d'affaire apporté total",
            'Entreprise',
            'Fonction',
            'Email Pro',
            'Mobile Pro',
            'Téléphone pro',
            'Pays Pro',
            'Adresse Pro',
            "Complément d'adresse Pro",
            'Ville Pro',
            'Allergie',
            'Nom Allergie',
            'Végétarien',
            'Handicap',
            'Préférence Nourriture',
            'Tables préférées',
            'Note',
            'Newsletter',
            'Restaurant de référence',
            'Date de mise à jour',
            "Date d'inscription",
            "Nombre d'annulation",
            'Nombre de no-show',
            'Total dépense',
        ],
        matchedHeaders: ['Dernière date de visite', 'Nombre de visites'],
        required: ['Prénom', 'Nom', 'Mobile Personnel', 'Email personnel'],
    },
    {
        key: 'zelty',
        headers: [
            'Nom',
            'Prénom',
            'N° de rue',
            'Ville',
            'Code postal',
            'Nom de rue',
            'N° de rue',
            'Téléphone',
            'Mail',
            "Date d'inscription",
            'Optin Mail',
            'CA actuel',
            'Optin SMS',
            'Statut',
            'Date de naissance',
            'Dernier restaurant',
            'Date de la dernière commande',
            'Nombre de commandes',
            'CA',
            'Points de fidélités',
            'Info interne',
            'Info client',
            "Complément d'adresse",
            'Batiment',
            'Porte',
            'Étage',
            'Digicode',
            'Identifiant externe',
            'Carte fidélité',
            'VIP',
            'Téléphone 2',
            'Entreprise',
            'ID',
        ],
        required: ['Nom', 'Prénom', 'Téléphone', 'Mail'],
    },
    {
        key: 'malou',
        headers: [
            'Civilité (H/F/NSP)',
            'Prénom',
            'Nom',
            'Pays',
            'Ville',
            'Code Postal',
            'Numéro de téléphone',
            'Email',
            'Langue parlée',
            'Date de la dernière réservation ou du click and collect',
            'Nombre de visites/réservations',
            'Accepte de recevoir des mails',
            'Accepte de recevoir des sms',
        ],
        required: ['Nom', 'Prénom', 'Numéro de téléphone', 'Email'],
    },
]);

export enum ClientFileError {
    EMPTY = 'empty_file',
    MISSING = 'missing_headers',
}

export const ubereatsClientCredentials = {
    key: 'UBEREATS_CLIENT_CREDENTIALS',
    ttl: 2592000, // from ubereats doc: https://developer.uber.com/docs/eats/guides/authentication#example-response
};
